import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, Search, Shield } from "lucide-react";

export const Route = createFileRoute("/admin/audit")({
  component: AuditLogPage,
});

function AuditLogPage() {
  const [q, setQ] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["audit", q],
    queryFn: () => apiFetch(`/api/audit?q=${encodeURIComponent(q)}&limit=100`, { schema: z.object({ items: z.array(z.any()) }) }).catch(() => ({ items: [] })),
  });

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <ClipboardList className="h-5 w-5" /> Journal d'audit
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">WORM · Hash chain SHA-256 · Immuable · 7 ans minimum (HIPAA / CNDP)</p>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Rechercher (utilisateur, action, entité)" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Événements</CardTitle>
          <CardDescription>WORM = Write Once Read Many · Toute modification brise la chaîne hash</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="text-sm text-muted-foreground">Chargement...</div>
          ) : (
            <ul className="space-y-1">
              {data?.items.map((e: any) => (
                <li key={e.id} className="flex items-center gap-3 rounded-md border border-white/5 bg-white/[0.02] p-2 text-sm">
                  <Shield className="h-3 w-3 text-muted-foreground" />
                  <span className="font-mono text-xs">{new Date(e.occurredAt).toLocaleString("fr-FR")}</span>
                  <Badge variant="outline">{e.action}</Badge>
                  <span className="flex-1 truncate">{e.entityType}/{e.entityId}</span>
                  <span className="text-xs text-muted-foreground">{e.actorId}</span>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
